var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSittingMartian = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 81,
  height: 70,
  viewBox: "0 0 81 70",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m33.03 30.746-1.393-2.825-1.36 2.825 1.36.715 1.393-.715Zm-4.326 0-1.554-2.825-1.591 2.825 1.591.715 1.554-.715Zm-4.325 0-1.554-2.825-1.592 2.825 1.592.715 1.554-.715Zm-4.719 0-1.376-2.825-1.376 2.825 1.376.715 1.377-.715Zm-4.325 0-1.392-2.825-1.36 2.825 1.36.715 1.392-.715ZM30.67 24.67l-1.36 2.858-1.392-2.858 1.393-.681 1.36.68Zm-4.325 0-1.592 2.858L23.2 24.67l1.554-.681 1.592.68Zm-4.325 0-1.592 2.858-1.554-2.858 1.554-.681 1.592.68Zm-4.719 0-1.36 2.858-1.392-2.858 1.393-.681 1.36.68Z",
  fill: "#D5D3DD",
  style: {
    fill: "color(display-p3 .8353 .8275 .8667)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m35.39 69.995.062-5.709-2.248-11.59c6.76-.589 12.407 5.008 12.407 10.099v1.896l5.49 5.304H35.39Z",
  fill: "#797E18",
  style: {
    fill: "color(display-p3 .4745 .4941 .0941)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.861 47.964 0 43.083l8.861-4.88v9.76Z",
  fill: "#E2CBB5",
  style: {
    fill: "color(display-p3 .8863 .7961 .7098)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.861 40.696 0 35.78l8.861-4.88v9.796Z",
  fill: "#E2CBB5",
  style: {
    fill: "color(display-p3 .8863 .7961 .7098)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.861 33.392 0 28.476l8.861-4.88v9.796Z",
  fill: "#E2CBB5",
  style: {
    fill: "color(display-p3 .8863 .7961 .7098)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.463 40.899H33.029V30.674h19.434L48.12 34.06l5.356 1.727-5.356 1.728 4.343 3.385Z",
  fill: "#797E18",
  style: {
    fill: "color(display-p3 .4736 .4958 .095)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.862 30.674c-1.624 0-2.852-1.334-2.852-2.95 0-1.614 1.34-2.949 2.963-2.949l19.04-.007V11.496c0-2.458-.636-4.46-1.8-5.934l1.94-1.735c.566.351 1.272.562 2.084.562a.744.744 0 0 0 .741-.737.722.722 0 0 0-.741-.738c-1.412 0-2.19-.807-2.19-2.177a.744.744 0 0 0-.74-.737.744.744 0 0 0-.742.737c0 .808.212 1.51.565 2.072l-1.942 1.735c-1.482-1.194-3.46-1.791-5.966-1.791l-8.73.007c-2.472 0-4.484.632-5.967 1.791L7.583 2.816c.353-.561.565-1.264.565-2.071a.744.744 0 0 0-.741-.738.744.744 0 0 0-.741.738c0 1.404-.812 2.177-2.19 2.177a.744.744 0 0 0-.74.737c0 .421.317.737.74.737.813 0 1.519-.21 2.084-.561L8.5 5.569C7.3 7.044 6.7 9.01 6.7 11.503v45.45c0 3.441 4.172 3.805 9.42 5.968h14.292c.812 0 1.452.668 1.452 1.475L31.85 70h15.58l-5.356-5.309v-1.896c0-5.091-4.04-9.396-9.017-10.098v-8.66l19.165.008-4.258-3.413 5.224-1.72-5.224-1.72L52.2 33.82l-19.165-.007v-3.146l-19.172.007Z",
  fill: "#9FA628",
  style: {
    fill: "color(display-p3 .6235 .651 .1569)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.806 21.56a3.31 3.31 0 0 0 3.318-3.301 3.31 3.31 0 0 0-3.318-3.3 3.31 3.31 0 0 0-3.319 3.3 3.31 3.31 0 0 0 3.319 3.3Z",
  fill: "#fff",
  style: {
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.81 20.084a1.83 1.83 0 0 0 1.835-1.826 1.83 1.83 0 0 0-1.836-1.826 1.83 1.83 0 0 0-1.835 1.826 1.83 1.83 0 0 0 1.835 1.826Z",
  fill: "#BF6C35",
  style: {
    fill: "color(display-p3 .749 .4235 .2078)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.604 21.56a3.31 3.31 0 0 0 3.318-3.301 3.31 3.31 0 0 0-3.318-3.3 3.31 3.31 0 0 0-3.319 3.3 3.31 3.31 0 0 0 3.319 3.3Z",
  fill: "#fff",
  style: {
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.607 20.084a1.83 1.83 0 0 0 1.836-1.826 1.83 1.83 0 0 0-1.836-1.826 1.83 1.83 0 0 0-1.835 1.826 1.83 1.83 0 0 0 1.835 1.826Z",
  fill: "#BF6C35",
  style: {
    fill: "color(display-p3 .749 .4235 .2078)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.801 50.73a.787.787 0 1 0-1.573 0v16.307c0 .747-.63 1.39-1.447 1.39h-3.664a.786.786 0 0 0 0 1.573h3.664c.892 0 1.704-.384 2.26-.999.546.61 1.324.999 2.207.999h3.665a.786.786 0 0 0 0-1.573h-3.665c-.758 0-1.447-.665-1.447-1.573V50.73Z",
  fill: "#ABA8AD",
  style: {
    fill: "color(display-p3 .6706 .6588 .6784)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.9 47.191c-1.01 0-1.87.77-1.87 1.77v1.77H81v-1.77c0-1-.86-1.77-1.87-1.77H34.9Z",
  fill: "#663F4C",
  style: {
    fill: "color(display-p3 .4 .2471 .298)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.48 37.896 2.66-5.931a.36.36 0 0 0-.327-.504H69.83a.357.357 0 0 0-.328.504l2.66 5.93-2.172 5.757h8.762l-2.272-5.756Z",
  fill: "#BDDFE0",
  style: {
    fill: "color(display-p3 .7412 .8745 .8784)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.65 47.191h7.335c1.013 0 1.709-1.008 1.344-1.945l-.576-1.594H69.99l-.691 1.594a1.437 1.437 0 0 0 1.351 1.945Z",
  fill: "#8F513D",
  style: {
    fill: "color(display-p3 .5608 .3176 .2392)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m73.53 37.915-.37-6.454h-1.852l1.481 6.454-1.445 5.737h1.793l.393-5.737Z",
  fill: "#E7F7F7",
  style: {
    fill: "color(display-p3 .9059 .9686 .9686)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.137 43.652h-1.839l-.467 1.603c-.099.336-.06.694.106 1.005l.502.931h1.52v-1.77l.178-1.77Z",
  fill: "#B36C58",
  style: {
    fill: "color(display-p3 .702 .4235 .3451)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m75.844 37.915 1.484-6.454h-1.855l-.37 6.454.393 5.737h1.795l-1.447-5.737Z",
  fill: "#ACCDDD",
  style: {
    fill: "color(display-p3 .6745 .8039 .8667)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.33 43.652h-1.835l.182 1.77v1.769h1.517l.5-.93c.167-.312.205-.67.107-1.006l-.47-1.603Z",
  fill: "#663F4C",
  style: {
    fill: "color(display-p3 .4 .2471 .298)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.136 40.899V35h-2.79c-.256 0-.43.273-.324.52l1.043 2.43-.908 2.447c-.089.24.082.502.331.502h2.648Zm2.359 0V35h2.79c.256 0 .43.273.324.52l-1.043 2.43.908 2.447c.089.24-.082.502-.331.502h-2.648Z",
  fill: "#F2AE53",
  style: {
    fill: "color(display-p3 .949 .6824 .3255)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.99 37.753h8.65",
  stroke: "#663F4C",
  style: {
    stroke: "color(display-p3 .4 .2471 .298)",
    strokeOpacity: 1
  },
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.321 38.611c.398 0 .721-.32.721-.714a.718.718 0 0 0-.72-.715.717.717 0 0 0-.721.715c0 .394.322.714.72.714Z",
  fill: "#663F4C",
  stroke: "#663F4C",
  style: {
    fill: "color(display-p3 .4 .2471 .298)",
    fillOpacity: 1,
    stroke: "color(display-p3 .4 .2471 .298)",
    strokeOpacity: 1
  },
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.32 37.896c-1.442.983-1.442 3.575-1.442 3.575l1.441-3.575Z",
  fill: "#663F4C",
  style: {
    fill: "color(display-p3 .4 .2471 .298)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.32 37.896c-1.442.983-1.442 3.575-1.442 3.575",
  stroke: "#663F4C",
  style: {
    stroke: "color(display-p3 .4 .2471 .298)",
    strokeOpacity: 1
  },
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.879 42.186c.398 0 .72-.32.72-.715a.718.718 0 0 0-.72-.715c-.398 0-.72.32-.72.715 0 .395.322.715.72.715Zm1.438-4.29c1.442.983 1.442 2.86 1.442 2.86l-1.442-2.86Z",
  fill: "#663F4C",
  style: {
    fill: "color(display-p3 .4 .2471 .298)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.317 37.896c1.442.983 1.442 2.86 1.442 2.86",
  stroke: "#663F4C",
  style: {
    stroke: "color(display-p3 .4 .2471 .298)",
    strokeOpacity: 1
  },
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.76 41.47c.399 0 .721-.32.721-.714a.718.718 0 0 0-.72-.715.718.718 0 0 0-.721.715c0 .395.323.715.72.715Z",
  fill: "#663F4C",
  style: {
    fill: "color(display-p3 .4 .2471 .298)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.857 45.225H3.932v10.894c0 4.41 3.623 7.982 8.095 7.982h17.07v-3.248c0-5.65-4.522-9.73-10.436-9.73h-5.908c-1.647 0-2.97-1.39-2.97-3.014 0-1.592-1.311-2.884-2.926-2.884Z",
  fill: "#7C3691",
  style: {
    fill: "color(display-p3 .4863 .2118 .5686)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.015 65.2a.393.393 0 0 1-.244.5l-8.464 2.922a.393.393 0 0 1-.257-.743l8.465-2.922a.395.395 0 0 1 .5.244Z",
  fill: "#ABA8AD",
  style: {
    fill: "color(display-p3 .6706 .6588 .6784)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.65 65.2a.393.393 0 0 1 .5-.243l8.465 2.922a.393.393 0 1 1-.256.743l-8.465-2.921a.393.393 0 0 1-.244-.5Z",
  fill: "#ABA8AD",
  style: {
    fill: "color(display-p3 .6706 .6588 .6784)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.822 64.234c.345.24.437.724.205 1.08l-2.819 4.341a.737.737 0 0 1-1.045.213.796.796 0 0 1-.205-1.082l2.82-4.34a.737.737 0 0 1 1.044-.212Zm4.992 0a.738.738 0 0 1 1.044.212l2.82 4.34a.796.796 0 0 1-.205 1.082.737.737 0 0 1-1.045-.213l-2.82-4.34a.796.796 0 0 1 .206-1.081Z",
  fill: "#663F4C",
  style: {
    fill: "color(display-p3 .4 .2471 .298)",
    fillOpacity: 1
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m52.342 45.098 6.263-19.275 9.691-3.21-7.5 22.485h-8.454Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.853 22.057a.79.79 0 0 1 .19.805l-7.5 22.485a.786.786 0 0 1-.746.538h-8.455a.786.786 0 0 1-.748-1.03l6.263-19.275a.786.786 0 0 1 .5-.504l9.692-3.21a.786.786 0 0 1 .804.191Zm-9.623 4.388-5.805 17.867h6.805l6.824-20.46-7.824 2.593Z",
  fill: "url(#b)"
})), /*#__PURE__*/React.createElement("path", {
  d: "m58.94 44.385 4.784-15.337-4.416 1.096-4.416 14.24h4.048Z",
  fill: "#fff",
  style: {
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.627 47.191H39.64c-.828 0-1.5-.704-1.5-1.573v-1.573h23.986v1.573c0 .87-.674 1.573-1.499 1.573Z",
  fill: "#D5D3DD",
  style: {
    fill: "color(display-p3 .8353 .8275 .8667)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m71.37 24.389-6.179 19.148a1.472 1.472 0 0 1-1.847.95l-1.403-.442 7.135-21.875 1.402.442c.773.245 1.14 1.006.893 1.777Z",
  fill: "#D5D3DD",
  style: {
    fill: "color(display-p3 .8353 .8275 .8667)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 60.265,
  y1: 44.221,
  x2: 60.265,
  y2: 22.463,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.005,
  stopColor: "#E946B6",
  style: {
    stopColor: "color(display-p3 .9137 .2745 .7137)",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.463,
  stopColor: "#653289",
  style: {
    stopColor: "color(display-p3 .3961 .1961 .5373)",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#191F34",
  style: {
    stopColor: "color(display-p3 .098 .1216 .2039)",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 60.319,
  y1: 22.613,
  x2: 60.319,
  y2: 45.098,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D3DD",
  style: {
    stopColor: "color(display-p3 .8415 .8275 .8667)",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9691A7",
  style: {
    stopColor: "color(display-p3 .5866 .5697 .6542)",
    stopOpacity: 1
  }
}))));
export { SvgSittingMartian as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODEiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA4MSA3MCIgZmlsbD0ibm9uZSIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Im0zMy4wMyAzMC43NDYtMS4zOTMtMi44MjUtMS4zNiAyLjgyNSAxLjM2LjcxNSAxLjM5My0uNzE1Wk0yOC43MDQgMzAuNzQ2bC0xLjU1NC0yLjgyNS0xLjU5MSAyLjgyNSAxLjU5MS43MTUgMS41NTQtLjcxNVpNMjQuMzc5IDMwLjc0NmwtMS41NTQtMi44MjUtMS41OTIgMi44MjUgMS41OTIuNzE1IDEuNTU0LS43MTVaTTE5LjY2IDMwLjc0NmwtMS4zNzYtMi44MjUtMS4zNzYgMi44MjUgMS4zNzYuNzE1IDEuMzc3LS43MTVaTTE1LjMzNSAzMC43NDZsLTEuMzkyLTIuODI1LTEuMzYgMi44MjUgMS4zNi43MTUgMS4zOTItLjcxNVpNMzAuNjcgMjQuNjdsLTEuMzYgMi44NTgtMS4zOTItMi44NTggMS4zOTMtLjY4MSAxLjM2LjY4Wk0yNi4zNDUgMjQuNjdsLTEuNTkyIDIuODU4TDIzLjIgMjQuNjdsMS41NTQtLjY4MSAxLjU5Mi42OFpNMjIuMDIgMjQuNjdsLTEuNTkyIDIuODU4LTEuNTU0LTIuODU4IDEuNTU0LS42ODEgMS41OTIuNjhaTTE3LjMwMSAyNC42N2wtMS4zNiAyLjg1OC0xLjM5Mi0yLjg1OCAxLjM5My0uNjgxIDEuMzYuNjhaIiBmaWxsPSIjRDVEM0REIiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC44MzUzIC44Mjc1IC44NjY3KTtmaWxsLW9wYWNpdHk6MSIvPgogIDxwYXRoIGQ9Im0zNS4zOSA2OS45OTUuMDYyLTUuNzA5LTIuMjQ4LTExLjU5YzYuNzYtLjU4OSAxMi40MDcgNS4wMDggMTIuNDA3IDEwLjA5OXYxLjg5Nmw1LjQ5IDUuMzA0SDM1LjM5WiIgZmlsbD0iIzc5N0UxOCIgc3R5bGU9ImZpbGw6Y29sb3IoZGlzcGxheS1wMyAuNDc0NSAuNDk0MSAuMDk0MSk7ZmlsbC1vcGFjaXR5OjEiLz4KICA8cGF0aCBkPSJNOC44NjEgNDcuOTY0IDAgNDMuMDgzbDguODYxLTQuODh2OS43NloiIGZpbGw9IiNFMkNCQjUiIHN0eWxlPSJmaWxsOmNvbG9yKGRpc3BsYXktcDMgLjg4NjMgLjc5NjEgLjcwOTgpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTguODYxIDQwLjY5NiAwIDM1Ljc4bDguODYxLTQuODh2OS43OTZaIiBmaWxsPSIjRTJDQkI1IiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC44ODYzIC43OTYxIC43MDk4KTtmaWxsLW9wYWNpdHk6MSIvPgogIDxwYXRoIGQ9Ik04Ljg2MSAzMy4zOTIgMCAyOC40NzZsOC44NjEtNC44OHY5Ljc5NloiIGZpbGw9IiNFMkNCQjUiIHN0eWxlPSJmaWxsOmNvbG9yKGRpc3BsYXktcDMgLjg4NjMgLjc5NjEgLjcwOTgpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTUyLjQ2MyA0MC44OTlIMzMuMDI5VjMwLjY3NGgxOS40MzRMNDguMTIgMzQuMDZsNS4zNTYgMS43MjctNS4zNTYgMS43MjggNC4zNDMgMy4zODVaIiBmaWxsPSIjNzk3RTE4IiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC40NzM2IC40OTU4IC4wOTUpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTEzLjg2MiAzMC42NzRjLTEuNjI0IDAtMi44NTItMS4zMzQtMi44NTItMi45NSAwLTEuNjE0IDEuMzQtMi45NDkgMi45NjMtMi45NDlsMTkuMDQtLjAwN1YxMS40OTZjMC0yLjQ1OC0uNjM2LTQuNDYtMS44LTUuOTM0bDEuOTQtMS43MzVjLjU2Ni4zNTEgMS4yNzIuNTYyIDIuMDg0LjU2MmEuNzQ0Ljc0NCAwIDAgMCAuNzQxLS43MzcuNzIyLjcyMiAwIDAgMC0uNzQxLS43MzhjLTEuNDEyIDAtMi4xOS0uODA3LTIuMTktMi4xNzdhLjc0NC43NDQgMCAwIDAtLjc0LS43MzcuNzQ0Ljc0NCAwIDAgMC0uNzQyLjczN2MwIC44MDguMjEyIDEuNTEuNTY1IDIuMDcybC0xLjk0MiAxLjczNWMtMS40ODItMS4xOTQtMy40Ni0xLjc5MS01Ljk2Ni0xLjc5MWwtOC43My4wMDdjLTIuNDcyIDAtNC40ODQuNjMyLTUuOTY3IDEuNzkxTDcuNTgzIDIuODE2Yy4zNTMtLjU2MS41NjUtMS4yNjQuNTY1LTIuMDcxYS43NDQuNzQ0IDAgMCAwLS43NDEtLjczOC43NDQuNzQ0IDAgMCAwLS43NDEuNzM4YzAgMS40MDQtLjgxMiAyLjE3Ny0yLjE5IDIuMTc3YS43NDQuNzQ0IDAgMCAwLS43NC43MzdjMCAuNDIxLjMxNy43MzcuNzQuNzM3LjgxMyAwIDEuNTE5LS4yMSAyLjA4NC0uNTYxTDguNSA1LjU2OWMtMS4yIDEuNDc1LTEuOCAzLjQ0MS0xLjggNS45MzR2NDUuNDVjMCAzLjQ0MSA0LjE3MiAzLjgwNSA5LjQyIDUuOTY4aDE0LjI5MmMuODEyIDAgMS40NTIuNjY4IDEuNDUyIDEuNDc1TDMxLjg1IDcwaDE1LjU4bC01LjM1Ni01LjMwOXYtMS44OTZjMC01LjA5MS00LjA0LTkuMzk2LTkuMDE3LTEwLjA5OHYtOC42NmwxOS4xNjUuMDA4LTQuMjU4LTMuNDEzIDUuMjI0LTEuNzItNS4yMjQtMS43MiA0LjIzNi0zLjM3Mi0xOS4xNjUtLjAwN3YtMy4xNDZsLTE5LjE3Mi4wMDdaIiBmaWxsPSIjOUZBNjI4IiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC42MjM1IC42NTEgLjE1NjkpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTE1LjgwNiAyMS41NmEzLjMxIDMuMzEgMCAwIDAgMy4zMTgtMy4zMDEgMy4zMSAzLjMxIDAgMCAwLTMuMzE4LTMuMyAzLjMxIDMuMzEgMCAwIDAtMy4zMTkgMy4zIDMuMzEgMy4zMSAwIDAgMCAzLjMxOSAzLjNaIiBmaWxsPSIjZmZmIiBzdHlsZT0iZmlsbDojZmZmO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTE1LjgxIDIwLjA4NGExLjgzIDEuODMgMCAwIDAgMS44MzUtMS44MjYgMS44MyAxLjgzIDAgMCAwLTEuODM2LTEuODI2IDEuODMgMS44MyAwIDAgMC0xLjgzNSAxLjgyNiAxLjgzIDEuODMgMCAwIDAgMS44MzUgMS44MjZaIiBmaWxsPSIjQkY2QzM1IiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC43NDkgLjQyMzUgLjIwNzgpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTI0LjYwNCAyMS41NmEzLjMxIDMuMzEgMCAwIDAgMy4zMTgtMy4zMDEgMy4zMSAzLjMxIDAgMCAwLTMuMzE4LTMuMyAzLjMxIDMuMzEgMCAwIDAtMy4zMTkgMy4zIDMuMzEgMy4zMSAwIDAgMCAzLjMxOSAzLjNaIiBmaWxsPSIjZmZmIiBzdHlsZT0iZmlsbDojZmZmO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTI0LjYwNyAyMC4wODRhMS44MyAxLjgzIDAgMCAwIDEuODM2LTEuODI2IDEuODMgMS44MyAwIDAgMC0xLjgzNi0xLjgyNiAxLjgzIDEuODMgMCAwIDAtMS44MzUgMS44MjYgMS44MyAxLjgzIDAgMCAwIDEuODM1IDEuODI2WiIgZmlsbD0iI0JGNkMzNSIgc3R5bGU9ImZpbGw6Y29sb3IoZGlzcGxheS1wMyAuNzQ5IC40MjM1IC4yMDc4KTtmaWxsLW9wYWNpdHk6MSIvPgogIDxwYXRoIGQ9Ik01Ny44MDEgNTAuNzNhLjc4Ny43ODcgMCAxIDAtMS41NzMgMHYxNi4zMDdjMCAuNzQ3LS42MyAxLjM5LTEuNDQ3IDEuMzloLTMuNjY0YS43ODYuNzg2IDAgMCAwIDAgMS41NzNoMy42NjRjLjg5MiAwIDEuNzA0LS4zODQgMi4yNi0uOTk5LjU0Ni42MSAxLjMyNC45OTkgMi4yMDcuOTk5aDMuNjY1YS43ODYuNzg2IDAgMCAwIDAtMS41NzNoLTMuNjY1Yy0uNzU4IDAtMS40NDctLjY2NS0xLjQ0Ny0xLjU3M1Y1MC43M1oiIGZpbGw9IiNBQkE4QUQiIHN0eWxlPSJmaWxsOmNvbG9yKGRpc3BsYXktcDMgLjY3MDYgLjY1ODggLjY3ODQpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTM0LjkgNDcuMTkxYy0xLjAxIDAtMS44Ny43Ny0xLjg3IDEuNzd2MS43N0g4MXYtMS43N2MwLTEtLjg2LTEuNzctMS44Ny0xLjc3SDM0LjlaIiBmaWxsPSIjNjYzRjRDIiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC40IC4yNDcxIC4yOTgpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0ibTc2LjQ4IDM3Ljg5NiAyLjY2LTUuOTMxYS4zNi4zNiAwIDAgMC0uMzI3LS41MDRINjkuODNhLjM1Ny4zNTcgMCAwIDAtLjMyOC41MDRsMi42NiA1LjkzLTIuMTcyIDUuNzU3aDguNzYybC0yLjI3Mi01Ljc1NloiIGZpbGw9IiNCRERGRTAiIHN0eWxlPSJmaWxsOmNvbG9yKGRpc3BsYXktcDMgLjc0MTIgLjg3NDUgLjg3ODQpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTcwLjY1IDQ3LjE5MWg3LjMzNWMxLjAxMyAwIDEuNzA5LTEuMDA4IDEuMzQ0LTEuOTQ1bC0uNTc2LTEuNTk0SDY5Ljk5bC0uNjkxIDEuNTk0YTEuNDM3IDEuNDM3IDAgMCAwIDEuMzUxIDEuOTQ1WiIgZmlsbD0iIzhGNTEzRCIgc3R5bGU9ImZpbGw6Y29sb3IoZGlzcGxheS1wMyAuNTYwOCAuMzE3NiAuMjM5Mik7ZmlsbC1vcGFjaXR5OjEiLz4KICA8cGF0aCBkPSJtNzMuNTMgMzcuOTE1LS4zNy02LjQ1NGgtMS44NTJsMS40ODEgNi40NTQtMS40NDUgNS43MzdoMS43OTNsLjM5My01LjczN1oiIGZpbGw9IiNFN0Y3RjciIHN0eWxlPSJmaWxsOmNvbG9yKGRpc3BsYXktcDMgLjkwNTkgLjk2ODYgLjk2ODYpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTczLjEzNyA0My42NTJoLTEuODM5bC0uNDY3IDEuNjAzYy0uMDk5LjMzNi0uMDYuNjk0LjEwNiAxLjAwNWwuNTAyLjkzMWgxLjUydi0xLjc3bC4xNzgtMS43N1oiIGZpbGw9IiNCMzZDNTgiIHN0eWxlPSJmaWxsOmNvbG9yKGRpc3BsYXktcDMgLjcwMiAuNDIzNSAuMzQ1MSk7ZmlsbC1vcGFjaXR5OjEiLz4KICA8cGF0aCBkPSJtNzUuODQ0IDM3LjkxNSAxLjQ4NC02LjQ1NGgtMS44NTVsLS4zNyA2LjQ1NC4zOTMgNS43MzdoMS43OTVsLTEuNDQ3LTUuNzM3WiIgZmlsbD0iI0FDQ0RERCIgc3R5bGU9ImZpbGw6Y29sb3IoZGlzcGxheS1wMyAuNjc0NSAuODAzOSAuODY2Nyk7ZmlsbC1vcGFjaXR5OjEiLz4KICA8cGF0aCBkPSJNNzcuMzMgNDMuNjUyaC0xLjgzNWwuMTgyIDEuNzd2MS43NjloMS41MTdsLjUtLjkzYy4xNjctLjMxMi4yMDUtLjY3LjEwNy0xLjAwNmwtLjQ3LTEuNjAzWiIgZmlsbD0iIzY2M0Y0QyIgc3R5bGU9ImZpbGw6Y29sb3IoZGlzcGxheS1wMyAuNCAuMjQ3MSAuMjk4KTtmaWxsLW9wYWNpdHk6MSIvPgogIDxwYXRoIGQ9Ik03My4xMzYgNDAuODk5VjM1aC0yLjc5Yy0uMjU2IDAtLjQzLjI3My0uMzI0LjUybDEuMDQzIDIuNDMtLjkwOCAyLjQ0N2MtLjA4OS4yNC4wODIuNTAyLjMzMS41MDJoMi42NDhaTTc1LjQ5NSA0MC44OTlWMzVoMi43OWMuMjU2IDAgLjQzLjI3My4zMjQuNTJsLTEuMDQzIDIuNDMuOTA4IDIuNDQ3Yy4wODkuMjQtLjA4Mi41MDItLjMzMS41MDJoLTIuNjQ4WiIgZmlsbD0iI0YyQUU1MyIgc3R5bGU9ImZpbGw6Y29sb3IoZGlzcGxheS1wMyAuOTQ5IC42ODI0IC4zMjU1KTtmaWxsLW9wYWNpdHk6MSIvPgogIDxwYXRoIGQ9Ik02OS45OSAzNy43NTNoOC42NSIgc3Ryb2tlPSIjNjYzRjRDIiBzdHlsZT0ic3Ryb2tlOmNvbG9yKGRpc3BsYXktcDMgLjQgLjI0NzEgLjI5OCk7c3Ryb2tlLW9wYWNpdHk6MSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogIDxwYXRoIGQ9Ik03NC4zMjEgMzguNjExYy4zOTggMCAuNzIxLS4zMi43MjEtLjcxNGEuNzE4LjcxOCAwIDAgMC0uNzItLjcxNWMtLjM5OSAwLS43MjEuMzItLjcyMS43MTUgMCAuMzk0LjMyMi43MTQuNzIuNzE0WiIgZmlsbD0iIzY2M0Y0QyIgc3Ryb2tlPSIjNjYzRjRDIiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC40IC4yNDcxIC4yOTgpO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpjb2xvcihkaXNwbGF5LXAzIC40IC4yNDcxIC4yOTgpO3N0cm9rZS1vcGFjaXR5OjEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8cGF0aCBkPSJNNzQuMzIgMzcuODk2Yy0xLjQ0Mi45ODMtMS40NDIgMy41NzUtMS40NDIgMy41NzVsMS40NDEtMy41NzVaIiBmaWxsPSIjNjYzRjRDIiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC40IC4yNDcxIC4yOTgpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTc0LjMyIDM3Ljg5NmMtMS40NDIuOTgzLTEuNDQyIDMuNTc1LTEuNDQyIDMuNTc1IiBzdHJva2U9IiM2NjNGNEMiIHN0eWxlPSJzdHJva2U6Y29sb3IoZGlzcGxheS1wMyAuNCAuMjQ3MSAuMjk4KTtzdHJva2Utb3BhY2l0eToxIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgPHBhdGggZD0iTTcyLjg3OSA0Mi4xODZjLjM5OCAwIC43Mi0uMzIuNzItLjcxNWEuNzE4LjcxOCAwIDAgMC0uNzItLjcxNWMtLjM5OCAwLS43Mi4zMi0uNzIuNzE1IDAgLjM5NS4zMjIuNzE1LjcyLjcxNVpNNzQuMzE3IDM3Ljg5NmMxLjQ0Mi45ODMgMS40NDIgMi44NiAxLjQ0MiAyLjg2bC0xLjQ0Mi0yLjg2WiIgZmlsbD0iIzY2M0Y0QyIgc3R5bGU9ImZpbGw6Y29sb3IoZGlzcGxheS1wMyAuNCAuMjQ3MSAuMjk4KTtmaWxsLW9wYWNpdHk6MSIvPgogIDxwYXRoIGQ9Ik03NC4zMTcgMzcuODk2YzEuNDQyLjk4MyAxLjQ0MiAyLjg2IDEuNDQyIDIuODYiIHN0cm9rZT0iIzY2M0Y0QyIgc3R5bGU9InN0cm9rZTpjb2xvcihkaXNwbGF5LXAzIC40IC4yNDcxIC4yOTgpO3N0cm9rZS1vcGFjaXR5OjEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8cGF0aCBkPSJNNzUuNzYgNDEuNDdjLjM5OSAwIC43MjEtLjMyLjcyMS0uNzE0YS43MTguNzE4IDAgMCAwLS43Mi0uNzE1Yy0uMzk4IDAtLjcyMS4zMi0uNzIxLjcxNSAwIC4zOTUuMzIzLjcxNS43Mi43MTVaIiBmaWxsPSIjNjYzRjRDIiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC40IC4yNDcxIC4yOTgpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZD0iTTYuODU3IDQ1LjIyNUgzLjkzMnYxMC44OTRjMCA0LjQxIDMuNjIzIDcuOTgyIDguMDk1IDcuOTgyaDE3LjA3di0zLjI0OGMwLTUuNjUtNC41MjItOS43My0xMC40MzYtOS43M2gtNS45MDhjLTEuNjQ3IDAtMi45Ny0xLjM5LTIuOTctMy4wMTQgMC0xLjU5Mi0xLjMxMS0yLjg4NC0yLjkyNi0yLjg4NFoiIGZpbGw9IiM3QzM2OTEiIHN0eWxlPSJmaWxsOmNvbG9yKGRpc3BsYXktcDMgLjQ4NjMgLjIxMTggLjU2ODYpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4wMTUgNjUuMmEuMzkzLjM5MyAwIDAgMS0uMjQ0LjVsLTguNDY0IDIuOTIyYS4zOTMuMzkzIDAgMCAxLS4yNTctLjc0M2w4LjQ2NS0yLjkyMmMuMjA1LS4wNy40MjkuMDM5LjUuMjQ0WiIgZmlsbD0iI0FCQThBRCIgc3R5bGU9ImZpbGw6Y29sb3IoZGlzcGxheS1wMyAuNjcwNiAuNjU4OCAuNjc4NCk7ZmlsbC1vcGFjaXR5OjEiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjY1IDY1LjJhLjM5My4zOTMgMCAwIDEgLjUtLjI0M2w4LjQ2NSAyLjkyMmEuMzkzLjM5MyAwIDEgMS0uMjU2Ljc0M2wtOC40NjUtMi45MjFhLjM5My4zOTMgMCAwIDEtLjI0NC0uNVoiIGZpbGw9IiNBQkE4QUQiIHN0eWxlPSJmaWxsOmNvbG9yKGRpc3BsYXktcDMgLjY3MDYgLjY1ODggLjY3ODQpO2ZpbGwtb3BhY2l0eToxIi8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy44MjIgNjQuMjM0Yy4zNDUuMjQuNDM3LjcyNC4yMDUgMS4wOGwtMi44MTkgNC4zNDFhLjczNy43MzcgMCAwIDEtMS4wNDUuMjEzLjc5Ni43OTYgMCAwIDEtLjIwNS0xLjA4MmwyLjgyLTQuMzRhLjczNy43MzcgMCAwIDEgMS4wNDQtLjIxMlpNMTguODE0IDY0LjIzNGEuNzM4LjczOCAwIDAgMSAxLjA0NC4yMTJsMi44MiA0LjM0YS43OTYuNzk2IDAgMCAxLS4yMDUgMS4wODIuNzM3LjczNyAwIDAgMS0xLjA0NS0uMjEzbC0yLjgyLTQuMzRhLjc5Ni43OTYgMCAwIDEgLjIwNi0xLjA4MVoiIGZpbGw9IiM2NjNGNEMiIHN0eWxlPSJmaWxsOmNvbG9yKGRpc3BsYXktcDMgLjQgLjI0NzEgLjI5OCk7ZmlsbC1vcGFjaXR5OjEiLz4KICA8cGF0aCBkPSJtNTIuMzQyIDQ1LjA5OCA2LjI2My0xOS4yNzUgOS42OTEtMy4yMS03LjUgMjIuNDg1aC04LjQ1NFoiIGZpbGw9InVybCgjYSkiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTY4Ljg1MyAyMi4wNTdjLjIxLjIxLjI4My41MjIuMTkuODA1bC03LjUgMjIuNDg1YS43ODYuNzg2IDAgMCAxLS43NDYuNTM4aC04LjQ1NWEuNzg2Ljc4NiAwIDAgMS0uNzQ4LTEuMDNsNi4yNjMtMTkuMjc1YS43ODYuNzg2IDAgMCAxIC41LS41MDRsOS42OTItMy4yMWEuNzg2Ljc4NiAwIDAgMSAuODA0LjE5MVptLTkuNjIzIDQuMzg4LTUuODA1IDE3Ljg2N2g2LjgwNWw2LjgyNC0yMC40Ni03LjgyNCAyLjU5M1oiIGZpbGw9InVybCgjYikiLz4KICA8cGF0aCBkPSJtNTguOTQgNDQuMzg1IDQuNzg0LTE1LjMzNy00LjQxNiAxLjA5Ni00LjQxNiAxNC4yNGg0LjA0OFoiIGZpbGw9IiNmZmYiIHN0eWxlPSJmaWxsOiNmZmY7ZmlsbC1vcGFjaXR5OjEiLz4KICA8cGF0aCBkPSJNNjAuNjI3IDQ3LjE5MUgzOS42NGMtLjgyOCAwLTEuNS0uNzA0LTEuNS0xLjU3M3YtMS41NzNoMjMuOTg2djEuNTczYzAgLjg3LS42NzQgMS41NzMtMS40OTkgMS41NzNaIiBmaWxsPSIjRDVEM0REIiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC44MzUzIC44Mjc1IC44NjY3KTtmaWxsLW9wYWNpdHk6MSIvPgogIDxwYXRoIGQ9Im03MS4zNyAyNC4zODktNi4xNzkgMTkuMTQ4YTEuNDcyIDEuNDcyIDAgMCAxLTEuODQ3Ljk1bC0xLjQwMy0uNDQyIDcuMTM1LTIxLjg3NSAxLjQwMi40NDJjLjc3My4yNDUgMS4xNCAxLjAwNi44OTMgMS43NzdaIiBmaWxsPSIjRDVEM0REIiBzdHlsZT0iZmlsbDpjb2xvcihkaXNwbGF5LXAzIC44MzUzIC44Mjc1IC44NjY3KTtmaWxsLW9wYWNpdHk6MSIvPgogIDxkZWZzPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iNjAuMjY1IiB5MT0iNDQuMjIxIiB4Mj0iNjAuMjY1IiB5Mj0iMjIuNDYzIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iLjAwNSIgc3RvcC1jb2xvcj0iI0U5NDZCNiIgc3R5bGU9InN0b3AtY29sb3I6Y29sb3IoZGlzcGxheS1wMyAuOTEzNyAuMjc0NSAuNzEzNyk7c3RvcC1vcGFjaXR5OjEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIuNDYzIiBzdG9wLWNvbG9yPSIjNjUzMjg5IiBzdHlsZT0ic3RvcC1jb2xvcjpjb2xvcihkaXNwbGF5LXAzIC4zOTYxIC4xOTYxIC41MzczKTtzdG9wLW9wYWNpdHk6MSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxOTFGMzQiIHN0eWxlPSJzdG9wLWNvbG9yOmNvbG9yKGRpc3BsYXktcDMgLjA5OCAuMTIxNiAuMjAzOSk7c3RvcC1vcGFjaXR5OjEiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSI2MC4zMTkiIHkxPSIyMi42MTMiIHgyPSI2MC4zMTkiIHkyPSI0NS4wOTgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0Q3RDNERCIgc3R5bGU9InN0b3AtY29sb3I6Y29sb3IoZGlzcGxheS1wMyAuODQxNSAuODI3NSAuODY2Nyk7c3RvcC1vcGFjaXR5OjEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjOTY5MUE3IiBzdHlsZT0ic3RvcC1jb2xvcjpjb2xvcihkaXNwbGF5LXAzIC41ODY2IC41Njk3IC42NTQyKTtzdG9wLW9wYWNpdHk6MSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+Cjwvc3ZnPg==";